<template>
  <div v-if="count" class="wrapper">
    <span class="count">{{ count }}</span>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  padding: rem(2px) rem(3px);
  color: $white;
  text-align: center;
  background: $red;

  @include border_radius(4px);

  .count {
    width: 100%;
    font-size: rem(11px);
  }
}
</style>
